import { type PropsWithChildren } from 'react'
// import Alert from 'src/components/common/Alert'
import Navbar from 'src/components/common/Navbar'
import Toast from 'src/components/common/Toast'
import { useUI } from 'src/sdk/ui'
import { Footer } from './components/common/Footer/Footer'

import 'src/styles/pages/layout.scss'
import CartSidebar from './components/cart/CartSidebar'
// import TopBarAlert from './components/common/TopBarAlert/TopBarAlert'
import { RenderClient } from './components/RenderClient'
import { SmartBanner } from './components/sections/SmartBanner/SmartBanner'
import { GlobalNavigationProvider } from './contexts/global-navigation-context'

function Layout({ children }: PropsWithChildren) {
  const { displayMinicart } = useUI()
  const noScriptIframe = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KHXZHM4"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>`

  return (
    <div>
      <noscript dangerouslySetInnerHTML={{ __html: noScriptIframe }} />
      <div id="layout">
        <SmartBanner />
        <GlobalNavigationProvider>
          <Navbar />
        </GlobalNavigationProvider>
        <div className="w-full max-w-[1520px] min-h-[375px] my-0 mx-auto">
          <main>{children}</main>
        </div>
        <Footer />
        <Toast />
        <RenderClient>{displayMinicart && <CartSidebar />}</RenderClient>
      </div>
    </div>
  )
}

export default Layout
